const initialState = { processorGroups: [], filteredData: [], processorTerminalGroups: [], processingGroupHistory: [] };

export const PROCESSORGROUPSREDUCER = (state = initialState, action) => {

    switch (action.type) {
        case 'GET_PROCESSORGROUPS':
            return {
                ...state,
                processorGroups: action.data,
            }
        case 'FILTER_GROUPS':
            return {
                ...state,
                filteredData: action.data
            }
        case "GET_PROCESSOR_TERMINAL_GROUPS":
            return Object.assign({}, state, {
                processorTerminalGroups: {
                    ...state.processorTerminalGroups,
                    [action.key]: action.data,

                }
            });
        case "GET_PROCESSING_GROUP_HISTORY":
            return Object.assign({}, state,{
                 processingGroupHistory: {
                    ...state.processingGroupHistory,
                    [action.key]: action.data,
                }    
            });


        default:
            return state;
    }
}